"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Add_1 = __importDefault(require("@material-ui/icons/Add"));
const SettingsOutlined_1 = __importDefault(require("@material-ui/icons/SettingsOutlined"));
const FileCopyOutlined_1 = __importDefault(require("@material-ui/icons/FileCopyOutlined"));
const LaunchOutlined_1 = __importDefault(require("@material-ui/icons/LaunchOutlined"));
const RefreshOutlined_1 = __importDefault(require("@material-ui/icons/RefreshOutlined"));
const ButtonIcon = ({ type }) => {
    switch (type) {
        case 'add_plus':
            return react_1.default.createElement(Add_1.default, { fontSize: "small", role: "add" });
        case 'copy':
            return react_1.default.createElement(FileCopyOutlined_1.default, { fontSize: "small" });
        case 'external':
            return react_1.default.createElement(LaunchOutlined_1.default, { fontSize: "small" });
        case 'folder':
            return react_1.default.createElement(FileCopyOutlined_1.default, { fontSize: "small" });
        case 'refresh':
            return react_1.default.createElement(RefreshOutlined_1.default, { fontSize: "small" });
        case 'settings':
            return react_1.default.createElement(SettingsOutlined_1.default, { fontSize: "small" });
        default: {
            const IconComponent = type;
            return react_1.default.createElement(IconComponent, { fontSize: "small" });
        }
    }
};
exports.default = ButtonIcon;
//# sourceMappingURL=index.js.map